// Surface a sonner toast for newly-arrived buddy-related notifications.
// Used by NotificationBell's poll loop to highlight fresh events between polls.
import { toast } from 'sonner';

export const surfaceFreshNotificationToast = (n) => {
  if (n.type === 'buddy_workout_accepted') {
    toast.success(`${n.from_user_name || 'Your buddy'} joined the workout!`, { icon: '🎉' });
  } else if (n.type === 'buddy_workout_invite') {
    toast.info(`${n.from_user_name || 'Someone'} invited you to a workout`);
  } else if (n.type === 'buddy_workout_completed') {
    toast.success(`${n.from_user_name || 'Your buddy'} crushed a workout 💪`);
  } else if (n.type === 'buddy_session_ended') {
    toast.info(`${n.from_user_name || 'Your buddy'} ended the live session`, { icon: '📴' });
  }
};
